// data/items/cloth.js
// Cloth items for magic armor crafting - 6 tiers

export const CLOTH = [
    // Tier 1 - Linenweave
    {
        id: 'linenweave',
        name: 'Linenweave',
        color: '#F5F5DC',
        tier: 1,
        value: 20
    },
    // Tier 2 - Silkweave
    {
        id: 'silkweave',
        name: 'Silkweave',
        color: '#FFF8DC',
        tier: 2,
        value: 45
    },
    // Tier 3 - Aetherweave
    {
        id: 'aetherweave',
        name: 'Aetherweave',
        color: '#87CEEB',
        tier: 3,
        value: 80
    },
    // Tier 4 - Runebound Cloth
    {
        id: 'runebound_cloth',
        name: 'Runebound Cloth',
        color: '#9370DB',
        tier: 4,
        value: 130
    },
    // Tier 5 - Shadowweave
    {
        id: 'shadowweave',
        name: 'Shadowweave',
        color: '#5A5A8F',
        tier: 5,
        value: 200
    },
    // Tier 6 - Voidweave
    {
        id: 'voidweave',
        name: 'Voidweave',
        color: '#663399',
        tier: 6,
        value: 300
    }
];

export default CLOTH;
